import styled, { css } from 'styled-components';
import { Popper, Breadcrumb, Link, TextButton } from '@amzn/storm-ui';
import {
  gray100,
  gray400,
  gray500,
  gray800,
  gray900,
} from '../../../../colors';

// there is no way to change the caret color in the breadcrumbs
// so using the sibling selector is the best we have right now
export const StyledLink = styled(Link)<{
  ia2Enabled?: boolean;
}>`
  text-decoration: none;
  ${(props) =>
    props.ia2Enabled
      ? css`
          &:focus {
            outline-offset: -1px;
          }
        `
      : null}
  &:hover {
    text-decoration: underline;
  }
  &&& + span {
    color: ${gray500};
    margin-bottom: -2px;
  }
`;

export const StyledBreadcrumb = styled(Breadcrumb)`
  color: ${gray400};
`;

export const BreadcrumbsWrapper = styled.div`
  display: flex;
  align-items: center;
  & svg {
    opacity: 0.3;
  }
`;

export const EllipsisButton = styled(TextButton)`
  width: 36px;
  height: 18px;
  background: ${gray900};
  box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  justify-content: center;
  color: ${gray100};
  && {
    display: flex;
  }
  &:hover {
    background: ${gray800};
    color: ${gray100};
    box-shadow: 0px 2px 1px rgba(0, 0, 0, 0.2);
  }
  &:focus {
    outline-offset: -1px;
  }
`;

export const TruncatedPopper = styled(Popper)`
  z-index: 599;
  && svg {
    opacity: 1;
  }
`;

export const TruncatedBreadcrumbWrapper = styled.div`
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  flex: auto;
  align-items: center;
  && a {
    color: white;
  }
  && button {
    color: white;
  }
  & p {
    color: #a0aaba;
  }
`;

export const VisibilityWrapper = styled.div`
  display: flex;
  position: absolute;
  visibility: hidden;
`;

export const OuterContainer = styled.div<{
  noPageTitleBreadcrumb?: boolean;
}>`
  flex: auto;
  overflow: hidden;
  & nav {
    flex-wrap: nowrap;
    overflow: hidden;
    flex: auto;
    padding-right: ${({ theme }) => theme.spacing.base};
    ${(props) =>
      props.noPageTitleBreadcrumb &&
      css`
        & i:last-of-type {
          padding-right: 0px;
        }
      `}
  }
`;

export const SingleBreadcrumbWrapper = styled.span`
  & nav {
    display: inline-block;
  }
  & i:first-of-type {
    padding-left: 0px;
  }
`;
